import { Badge, BadgeColor } from '@billy/design-system'
import { TFunction } from 'i18next'
import React, { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { VoucherInboxState } from '../types'

type VoucherStatusProps = {
  state: VoucherInboxState
}

type Status = {
  text: string
  color: BadgeColor
}

const getVoucherStateToStatus = (
  t: TFunction,
): Record<Exclude<VoucherInboxState, VoucherInboxState.DELETED | VoucherInboxState.DUPLICATED>, Status> => ({
  [VoucherInboxState.RECEIVED]: { text: t('voucher.inbox.state.received'), color: 'accent' },
  [VoucherInboxState.RECORDED]: { text: t('voucher.inbox.state.recorded'), color: 'success' },
  [VoucherInboxState.ARCHIVED]: { text: t('voucher.inbox.state.archived'), color: 'neutral' },
  [VoucherInboxState.DISCARDED]: { text: t('voucher.inbox.state.discarded'), color: 'neutral' },
  [VoucherInboxState.NEED_INFO]: { text: t('voucher.inbox.state.need_info'), color: 'warning' },
  [VoucherInboxState.VOIDED]: { text: t('voucher.inbox.state.voided'), color: 'danger' },
})

export const VoucherStatus = ({ state, ...rest }: VoucherStatusProps): ReactElement => {
  const { t } = useTranslation()
  const voucherStateToStatus = useMemo(() => getVoucherStateToStatus(t), [t])
  const { text, color } = voucherStateToStatus[state]

  return (
    <Badge color={color} mode="subtle" {...rest}>
      {text}
    </Badge>
  )
}
